import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DependencyTracker2tg9lout2xnpn as DependencyTracker } from './DependencyTracker.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  ReactiveState__get_impl_reoidr323siyisyfdmv as ReactiveState__get_impl_reoidr,
} from '../core/ReactiveState.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { addAndRunListener8g331b1wn43q as addAndRunListener } from '../core/coreInterfaces.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var DependencyChangeListenerClass;
function DependencyChangeListener() {
  if (DependencyChangeListenerClass === VOID) {
    class $ extends DependencyTracker() {
      e2() {
        return Key_instance;
      }
      gai() {
        return this.fai();
      }
    }
    protoOf($).cd = get;
    protoOf($).fp = fold;
    protoOf($).ep = minusKey;
    protoOf($).gp = plus;
    initMetadataForClass($, 'DependencyChangeListener', VOID, VOID, [DependencyTracker(), Element()]);
    DependencyChangeListenerClass = $;
  }
  return DependencyChangeListenerClass;
}
function *_generator_await__mos7q6(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.pc().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $l$block_1: {
      var it = tmp0_safe_receiver;
      var cont = {_v: null};
      if (it.jai(_this__u8e3s4) == null) {
        it.kai(_this__u8e3s4, _this__u8e3s4.tah(() => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          var this_0 = _this__u8e3s4.qah();
          var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
          if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
            if (cont._v == null) {
              it.gai();
            }
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              var r = _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
              var tmp0_safe_receiver = cont._v;
              var tmp;
              if (tmp0_safe_receiver == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(r));
                tmp0_safe_receiver.rc(tmp$ret$2);
                cont._v = null;
                tmp = Unit_instance;
              }
              if (tmp == null) {
                it.fai();
              }
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
                var r_0 = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
                var tmp0_safe_receiver_0 = cont._v;
                var tmp_1;
                if (tmp0_safe_receiver_0 == null) {
                  tmp_1 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.coroutines.resume' call
                  // Inline function 'kotlin.Companion.success' call
                  var tmp$ret$7 = _Result___init__impl__xyqfz8(r_0);
                  tmp0_safe_receiver_0.rc(tmp$ret$7);
                  cont._v = null;
                  tmp_1 = Unit_instance;
                }
                if (tmp_1 == null) {
                  it.fai();
                }
              } else {
                var r_1 = _ReactiveState___get_raw__impl__92ipya(this_0);
                var tmp0_safe_receiver_1 = cont._v;
                var tmp_2;
                if (tmp0_safe_receiver_1 == null) {
                  tmp_2 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.coroutines.resume' call
                  // Inline function 'kotlin.Companion.success' call
                  var tmp$ret$12 = _Result___init__impl__xyqfz8(r_1);
                  tmp0_safe_receiver_1.rc(tmp$ret$12);
                  cont._v = null;
                  tmp_2 = Unit_instance;
                }
                if (tmp_2 == null) {
                  it.fai();
                }
              }
            }
          }
          return Unit_instance;
        }));
      }
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = _this__u8e3s4.qah();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
        cancellable.ra5();
        cont._v = cancellable;
        var tmp$ret$19 = cancellable.sa5();
        var tmp_0 = returnIfSuspended(tmp$ret$19, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        break $l$block_1;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          throw _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
            (tmp_1 == null ? true : !(tmp_1 == null)) || THROW_CCE();
            break $l$block_1;
          } else {
            _ReactiveState___get_raw__impl__92ipya(this_0);
            break $l$block_1;
          }
        }
      }
    }
  }
  var tmp_2 = awaitOnce(_this__u8e3s4, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function await_0(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_await__mos7q6.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_awaitOnce__gihbvn(_this__u8e3s4, $completion) {
  var state = _this__u8e3s4.qah();
  var tmp;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
  var tmp_0 = _ReactiveState___get_raw__impl__92ipya(state);
  if (!(tmp_0 instanceof InternalReactiveNotReady())) {
    tmp = ReactiveState__get_impl_reoidr(state);
  } else {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ra5();
    var it = cancellable;
    var remover = {_v: null};
    var alreadyRun = {_v: false};
    var done = {_v: false};
    remover._v = addAndRunListener(_this__u8e3s4, () => {
      var state = _this__u8e3s4.qah();
      var tmp;
      var tmp_0;
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_1 = _ReactiveState___get_raw__impl__92ipya(state);
      if (!(tmp_1 instanceof InternalReactiveNotReady())) {
        tmp_0 = !done._v;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        done._v = true;
        resumeState(it, state);
        var tmp0_safe_receiver = remover._v;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
        var tmp_2;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          alreadyRun._v = true;
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        tmp = tmp_2;
      }
      return Unit_instance;
    });
    if (alreadyRun._v)
      remover._v();
    it.ta7((it) => {
      remover._v();
      return Unit_instance;
    });
    var tmp$ret$5 = cancellable.sa5();
    var tmp_1 = returnIfSuspended(tmp$ret$5, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function awaitOnce(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitOnce__gihbvn.bind(VOID, _this__u8e3s4), $completion);
}
function resumeState(_this__u8e3s4, state) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(state);
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = CancellationException().ld('State not ready');
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    _this__u8e3s4.rc(tmp$ret$0);
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception_0 = _ReactiveState___get_raw__impl__92ipya(state).sah_1;
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception_0));
      _this__u8e3s4.rc(tmp$ret$3);
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp = _ReactiveState___get_raw__impl__92ipya(state).rah_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        var tmp$ret$6 = _Result___init__impl__xyqfz8(value);
        _this__u8e3s4.rc(tmp$ret$6);
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value_0 = _ReactiveState___get_raw__impl__92ipya(state);
        var tmp$ret$9 = _Result___init__impl__xyqfz8(value_0);
        _this__u8e3s4.rc(tmp$ret$9);
      }
    }
  }
}
function await_1(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.pc().cd(Key_instance);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    var last = {_v: _this__u8e3s4.f2()};
    if (it.jai(_this__u8e3s4) == null) {
      it.kai(_this__u8e3s4, _this__u8e3s4.tah(() => {
        var newVal = _this__u8e3s4.f2();
        var tmp;
        if (!equals(last._v, newVal)) {
          last._v = newVal;
          it.fai();
          tmp = Unit_instance;
        }
        return Unit_instance;
      }));
      last._v = _this__u8e3s4.f2();
    }
    return last._v;
  }
  if (tmp == null)
    return _this__u8e3s4.f2();
}
function rerunOn(listenable, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.pc().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    if (it.jai(listenable) == null) {
      it.kai(listenable, listenable.tah(() => {
        it.fai();
        return Unit_instance;
      }));
    }
  }
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  DependencyChangeListener as DependencyChangeListener1518w8dt8yuu7,
  awaitOnce as awaitOnce2ui7qqi9bvdeq,
  await_1 as awaitqeg6zusi9ora,
  await_0 as await1kke5zj2piplv,
  rerunOn as rerunOn28vy04vs1j44i,
};
//endregion

//# sourceMappingURL=DependencyChangeListener.mjs.map
